import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                MediExamPro
              </h1>
            </div>
            <nav className="flex gap-6">
              <a href="/" className="text-gray-700 dark:text-gray-300 hover:text-blue-600">
                Inicio
              </a>
              <a href="/pricing" className="text-gray-700 dark:text-gray-300 hover:text-blue-600">
                Planes
              </a>
              <a href="/privacy" className="text-blue-600 font-semibold">
                Privacidad
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          Política de Privacidad
        </h1>

        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Última actualización: {new Date().toLocaleDateString('es-PE')}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              1. Información que Recopilamos
            </h2>
            <div className="text-gray-700 dark:text-gray-300 mb-4">
              <h3 className="font-semibold mb-2">Información Personal:</h3>
              <ul className="list-disc list-inside ml-4 mb-4">
                <li>Nombre completo</li>
                <li>Dirección de correo electrónico</li>
                <li>Número de teléfono (opcional)</li>
                <li>Universidad o institución educativa (opcional)</li>
                <li>Año de graduación (opcional)</li>
              </ul>

              <h3 className="font-semibold mb-2">Información de Uso:</h3>
              <ul className="list-disc list-inside ml-4 mb-4">
                <li>Respuestas a preguntas</li>
                <li>Resultados de simulacros</li>
                <li>Tiempo de estudio</li>
                <li>Progreso y estadísticas</li>
                <li>Preferencias de estudio</li>
              </ul>

              <h3 className="font-semibold mb-2">Información Técnica:</h3>
              <ul className="list-disc list-inside ml-4 mb-4">
                <li>Dirección IP</li>
                <li>Tipo de navegador</li>
                <li>Sistema operativo</li>
                <li>Dispositivo utilizado</li>
                <li>Cookies y datos de sesión</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              2. Cómo Utilizamos su Información
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Utilizamos la información recopilada para:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
              <li>Proporcionar y mejorar nuestros servicios</li>
              <li>Personalizar su experiencia de aprendizaje</li>
              <li>Generar análisis y predicciones de rendimiento</li>
              <li>Comunicarnos con usted sobre su cuenta</li>
              <li>Enviar actualizaciones y notificaciones importantes</li>
              <li>Procesar pagos y gestionar suscripciones</li>
              <li>Prevenir fraude y garantizar la seguridad</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              3. Almacenamiento y Seguridad
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Sus datos se almacenan de forma segura en servidores de Supabase con encriptación SSL/TLS. Implementamos las siguientes medidas de seguridad:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
              <li>Encriptación de datos en tránsito y reposo</li>
              <li>Autenticación de dos factores (opcional)</li>
              <li>Acceso restringido a datos personales</li>
              <li>Auditorías de seguridad periódicas</li>
              <li>Respaldos automáticos diarios</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              4. Compartir Información
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              No vendemos ni alquilamos su información personal. Solo compartimos datos con:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
              <li><strong>Procesadores de pago:</strong> Culqi para procesar transacciones</li>
              <li><strong>Proveedores de servicios:</strong> Supabase para almacenamiento, Netlify para hosting</li>
              <li><strong>Autoridades legales:</strong> Cuando sea requerido por ley</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              5. Cookies y Tecnologías Similares
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Utilizamos cookies para:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
              <li>Mantener su sesión activa</li>
              <li>Recordar sus preferencias</li>
              <li>Analizar el uso del servicio</li>
              <li>Mejorar la experiencia del usuario</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Puede desactivar las cookies en su navegador, pero esto puede limitar algunas funcionalidades.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              6. Sus Derechos
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              De acuerdo con la Ley N° 29733 - Ley de Protección de Datos Personales del Perú, usted tiene derecho a:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 ml-4 mb-4">
              <li><strong>Acceso:</strong> Solicitar información sobre sus datos personales</li>
              <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
              <li><strong>Cancelación:</strong> Solicitar la eliminación de sus datos</li>
              <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Para ejercer estos derechos, contáctenos a: soporte@mediexampro.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              7. Retención de Datos
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Conservamos sus datos mientras su cuenta esté activa o según sea necesario para proporcionarle servicios. Si solicita la eliminación de su cuenta, eliminaremos sus datos personales dentro de 30 días, excepto cuando debamos conservarlos por obligaciones legales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              8. Menores de Edad
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              MediExamPro está dirigido a estudiantes y profesionales de medicina mayores de 18 años. No recopilamos intencionalmente información de menores de edad.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              9. Transferencias Internacionales
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Sus datos pueden ser transferidos y almacenados en servidores ubicados fuera del Perú. Nos aseguramos de que dichas transferencias cumplan con las leyes de protección de datos aplicables.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              10. Cambios en la Política
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Podemos actualizar esta política periódicamente. Le notificaremos sobre cambios significativos por correo electrónico o mediante un aviso en nuestra plataforma.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              11. Autoridad de Protección de Datos
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Si considera que el tratamiento de sus datos personales infringe la normativa, puede presentar una reclamación ante:
            </p>
            <div className="text-gray-700 dark:text-gray-300 ml-4">
              <p><strong>Autoridad Nacional de Protección de Datos Personales</strong></p>
              <p>Dirección: Scipión Llona 350, Miraflores, Lima</p>
              <p>Teléfono: (01) 204-8020</p>
              <p>Web: www.minjus.gob.pe</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              12. Contacto
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Para cualquier consulta sobre esta política de privacidad:
            </p>
            <div className="text-gray-700 dark:text-gray-300 ml-4">
              <p><strong>Responsable de Datos:</strong> GARCIA CASUSOL CESAR ALEXIS</p>
              <p><strong>RUC:</strong> 10709315302</p>
              <p><strong>Email:</strong> alexisgc90@gmail.com</p>
              <p><strong>WhatsApp:</strong> +51 997 268 543</p>
              <p><strong>Teléfono:</strong> +51 964 088 671</p>
              <p><strong>Dirección:</strong> Chiclayo, Perú</p>
            </div>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm text-gray-400">
            © 2024 MediExamPro. Todos los derechos reservados.
          </p>
          <div className="mt-4 flex justify-center gap-6">
            <a href="/privacy" className="text-gray-400 hover:text-white text-sm">
              Política de Privacidad
            </a>
            <a href="/terms" className="text-gray-400 hover:text-white text-sm">
              Términos y Condiciones
            </a>
            <a href="/pricing" className="text-gray-400 hover:text-white text-sm">
              Planes y Precios
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;